let enabled = false;

function coerce(val) {
  return val instanceof Error ? val.stack || val.message : val;
}

export default function debug(name) {
  return function(...args) {
    if (!enabled) {
      return false;
    }

    args[0] = `[${name}] ${coerce(args[0])}`;

    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    /* eslint-disable no-console */
    return (
      typeof console === "object" &&
      console.log &&
      Function.prototype.apply.call(console.log, console, args)
    );
    /* eslint-enable no-console */
  };
}

export function enable() {
  enabled = true;
}
export function disable() {
  enabled = false;
}
